var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_c('app-header',{attrs:{"title":"我的求购"}}),_vm._v(" "),_c('div',{staticClass:"upimg"},[_c('van-uploader',{attrs:{"deletable":false,"max-count":_vm.fileList.length,"file-list":_vm.fileList,"after-read":_vm.afterRead},on:{"delete":_vm.deleteImg}})],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-04c98009","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/mine/buy/buyImages.vue
// module id = null
// module chunks = 